/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, UseQueryResult, useQuery } from "@tanstack/react-query";
import { getCountries } from "api/services/common";
import { GetCountriesResponseType } from "api/response";
import { commonQueryKeys } from "./commonQueryKeys";

export type UseGetCountriesOptions<T = GetCountriesResponseType> = Omit<
  UseQueryOptions<GetCountriesResponseType, unknown, T>,
  "queryKey" | "queryFn"
> & {
  useV2?: boolean;
};

export function useGetCountries<T = GetCountriesResponseType>(options?: UseGetCountriesOptions<T>): UseQueryResult<T> {
  const { useV2 = false, ...queryOptions } = options ?? {};

  return useQuery<GetCountriesResponseType, unknown, T>({
    queryKey: commonQueryKeys.countries(useV2),
    queryFn: () => getCountries(useV2 ? { params: { use_v2: true } } : {}).then((res) => res.data),
    ...queryOptions,
  });
}
